import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendComscoreBeacon } from '@/libs/comscore';

const CONTENT_KEYS = ['id'];

const getRouteKey = (pathname, search) => {
  const params = new URLSearchParams(search);
  const picked = CONTENT_KEYS.filter((k) => params.get(k)).map((k) => `${k}=${params.get(k)}`);
  return picked.length ? `${pathname}?${picked.join('&')}` : pathname;
};

export const useComscorePageView = () => {
  const { pathname, search } = useLocation();
  const prevKeyRef = useRef(null);

  useEffect(() => {
    const key = getRouteKey(pathname, search);

    if (prevKeyRef.current === null) {
      prevKeyRef.current = key;
      return;
    }
    if (prevKeyRef.current === key) return;

    prevKeyRef.current = key;
    sendComscoreBeacon();
  }, [pathname, search]);
};
